/**
 * `#security` — `template.html` dòng 994–1010. Thứ tự 4 card là thứ tự thiết kế.
 *
 * `icon` khai union tại nguồn thay vì để suy ra `string`: cùng lý do với `modules.ts` — chỗ dùng
 * khỏi ép kiểu, và gõ sai một tên icon là lỗi biên dịch ngay ở đây chứ không phải icon rỗng lúc
 * render.
 */
interface SecurityCardCopy {
  readonly icon: 'server' | 'key-round' | 'scroll-text' | 'shield-check';
  readonly title: string;
  readonly body: string;
}

export const security = {
  eyebrow: 'Doanh nghiệp & triển khai',
  heading: 'Chạy trong hạ tầng của bạn, khi đó là yêu cầu bắt buộc.',
  lead: 'Nexa triển khai dạng cloud quản lý, private cloud, hoặc on-premise hoàn toàn — với cùng một bộ tính năng. NewEra Inc. đảm nhiệm việc chuyển đổi, tích hợp và đào tạo vận hành.',
  cards: [
    {
      icon: 'server',
      title: 'On-premise',
      body: 'Triển khai trong trung tâm dữ liệu của bạn; dữ liệu không rời khỏi mạng nội bộ.',
    },
    {
      icon: 'key-round',
      title: 'SSO & phân quyền',
      body: 'Đăng nhập một lần, phân quyền theo vai trò tới từng channel và dự án.',
    },
    {
      icon: 'scroll-text',
      title: 'Nhật ký & phê duyệt',
      body: 'Mọi phê duyệt và đổi trạng thái đều truy vết được tới người và thời điểm.',
    },
    {
      icon: 'shield-check',
      title: 'AI có phạm vi',
      body: 'Agent chỉ đọc đúng những nguồn mà dự án đã liên kết tường minh.',
    },
  ] as readonly SecurityCardCopy[],
};
